// src/components/Loading.js
import React from "react";
import medterrannefoodlogo from "assets/img/medterrannefoodlogo.png";

const Loading = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black-overlay z-52">
      <div className="grid grid-cols-1">
        <div className="center-items">
          {/* <img
            src={medterrannefoodlogo}
            alt="Loading..."
            className="xl:w-1/12 lg:w-4/12 w-3/12"
          /> */}
          <img
            src="https://i.ibb.co/jTqBRfw/loading-gif-1.gif"
            className="xl:w-12 mt-4 lg:w-12 w-8"
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;
